import React from 'react'
import {Header, Image, Loader} from 'semantic-ui-react'
import styled from "styled-components";
import { Box, Flex } from 'rebass'

import { __ } from '~/i18n'

import cartSuccess from '~/assets/img/cart-success.svg'
import cartFailure from '~/assets/img/cart-failure.svg'

import BlockingButton from '~/components/blocking-button'

import logic from './logic'

const SuccessContainer = styled.div`
  padding-top: 50px;
`;

const ErrorContainer = styled.div`
  padding-top: 50px;
`;

const HelpText = styled.div``;
const Buttons = styled.div`
  width: 270px;
  margin: 40px auto 20px;
  
  .ui.button {
    margin-bottom: 8px;
  }
`;

const AlignBox = styled(({ textAlign, ...rest }) => <Box {...rest} />)`
  text-align: ${props => (props.textAlign)}
`;


@logic
export default class OrderStep extends React.PureComponent {

  handleContinue = () => {
    const { cancel } = this.props.actions;

    cancel();
  };

  render() {
    const { retrying, cancelled, loading, showButton, showSpinner, infoText, activeOrder } = this.props;
    const { commit, cancel} = this.props.actions;

    let content = (
      <SuccessContainer>
        <Image src={ cartSuccess } centered/>
        <Header>{ __('Thank you for shopping with us!') }</Header>
        <HelpText>
          <p>{ __('You have successfully placed your order. You will receive an email confirmation shortly.') }</p>
          { infoText ? <p>{ infoText }</p> : null }
        </HelpText>
        <Buttons>
          { showButton ? <BlockingButton fluid positive onClick={ this.handleContinue } loading={ loading }>{ __('Continue') }</BlockingButton> : null }
          { showSpinner ? <Loader active inline='centered' /> : null }
        </Buttons>
      </SuccessContainer>
    );

    if(activeOrder && ['paid', 'authorized'].indexOf(activeOrder.payment_status) > -1) {
      content = (
        <SuccessContainer>
          <Image src={ cartSuccess } centered/>
          <Header>{ __('Thank you for shopping with us!') }</Header>
          <HelpText>
            <p>{ __('You have successfully placed your order.') }</p>
          </HelpText>
          <Buttons>
            <BlockingButton fluid positive onClick={ this.handleContinue }>{ __('Close') }</BlockingButton>
          </Buttons>
        </SuccessContainer>
      );
    }

    if(cancelled) {
      content = (
        <ErrorContainer>
          <Image src={ cartFailure } centered/>
          <Header>{ __('You cancelled the payment') }</Header>
          <HelpText>{ __('There was an error processing your payment. Most likely you cancelled the payment') }</HelpText>
          <Buttons>
            <BlockingButton fluid basic onClick={ () => { cancel() } } loading={ loading }>{ __('Close') }</BlockingButton>
          </Buttons>
        </ErrorContainer>
      );
    }

    if(retrying) {
      content = (
        <ErrorContainer>
          <Image src={ cartFailure } centered/>
          <Header>{ __('Something went wrong.') }</Header>
          <HelpText>{ __('There was an error processing your payment. Would you like to try again?') }</HelpText>
          <Buttons>
            <BlockingButton fluid positive onClick={ () => { commit() } } loading={ loading }>{ __('Retry') }</BlockingButton>
            <BlockingButton fluid basic onClick={ () => { cancel() } } loading={ loading }>{ __('Cancel') }</BlockingButton>
          </Buttons>
        </ErrorContainer>
      );
    }

    return (
      <Flex flexWrap='wrap' py={ 4 } justifyContent={ 'center' } mx={ -4 }>
        <AlignBox px={ 4 } width={ [ 1, 6/16 ] } textAlign='center'>
          { content }
        </AlignBox>
      </Flex>
    )
  }
}
